var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1230",
    stroke: "#C8D7F5",
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 19V9c0-.827.673-1.5 1.5-1.5h10c.827 0 1.5.673 1.5 1.5v10c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 14V4a1.5 1.5 0 0 1 1.5-1.5h10A1.5 1.5 0 0 1 17 4v1.5H9.5A2.5 2.5 0 0 0 7 8v7.5H5.5A1.5 1.5 0 0 1 4 14Z"
  })))));
};
export default SvgCopy;